import { render, staticRenderFns } from "./ResellerPanel.vue?vue&type=template&id=39895e80&"
import script from "./ResellerPanel.vue?vue&type=script&lang=js&"
export * from "./ResellerPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports